import React, { Component } from 'react';
import HeaderImage from '../src/images/header.png';
import { Grid, Divider, Dropdown, Button, Menu, Image, Message, Popup } from 'semantic-ui-react';
import AgencyInfo from './AgencyInfo';
import { Footer } from './layout/footer';
import 'semantic-ui-css/semantic.min.css';
import './index.css';
import config from './config.json';
import $ from 'jquery';
import sha256 from 'sha256';

const Authentication =
{
    token: "",
    isValid: false
};

class ResetPassword extends Component {

    constructor(props) {
        super(props);
        this.finishedExit = false;
    }

    state = {
        visible: false,
        mode: "Gmaps",
        agencies: [],
        selectedAgency: 9,
        selectedState: 1,
        activeItem: 'Reset',
        username: "",
        newPassword: "",
        oldPassword: "",
        confirmPassword: "",
        success: false,
        loginError: null,
        matchPassword: false,
        showLabel: false,
        shouldHideFooter: false,
        showOldPassword: false,
        showNewPassword: false,
        showConfirmPassword: false
    };

    handleOnFocusToHideFooter = () => {
        if (window.mobileAndTabletcheck()) {
            this.setState({ shouldHideFooter: true });
        }
    }
    handleOnFocusToBringFooter = () => {
        if (window.mobileAndTabletcheck()) {
            this.setState({ shouldHideFooter: false });
        }
    }
    handleItemClick = (e, { name }) => this.setState({ activeItem: 'Reset' })

    handleDismiss = () => {
        this.setState({ showLabel: false })
    }

    render() {

        const displayTabs = {
            "Reset":
                <div>
                    <Divider hidden />
                    <div className="pt-form-group pt-input-group pt-small" style={{ margin: 'auto', width: 200 }}>
                        <span className="pt-icon pt-icon-person"></span>
                        <input type="text" className="pt-input" value={this.state.username}
                            onFocus={this.handleOnFocusToHideFooter}
                            onBlur={this.handleOnFocusToBringFooter}
                            onChange={({ target }) => {
                                this.setState({ username: target.value });
                            }}

                            placeholder="Username" />
                    </div>
                    <Divider hidden />
                    <div className="pt-form-group pt-input-group pt-small" style={{ margin: 'auto', width: 200 }}>
                        <span className="pt-icon pt-icon-lock"></span>
                        <Popup

                            trigger={<input type={`${this.state.showOldPassword ? 'text' : 'password'}`} className="pt-input"
                                value={this.state.oldPassword}
                                onFocus={this.handleOnFocusToHideFooter}
                                onBlur={this.handleOnFocusToBringFooter}
                                onChange={({ target }) => {
                                    this.setState({ oldPassword: target.value });
                                }}

                                placeholder="Old Password" />}
                            header='Forgot Your Old Password?'
                            content='Please, go back and click on Forget Password option'
                            on='focus'
                        />
                        <span onClick={() => { this.setState({ showOldPassword: !this.state.showOldPassword }); }} className={`password-eye pt-icon ${this.state.showOldPassword ? 'pt-icon-eye-on' : 'pt-icon-eye-off'}`}></span>
                    </div>
                    <Divider hidden />
                    <div className="pt-form-group pt-input-group pt-small" style={{ margin: 'auto', width: 200 }}>
                        <span className="pt-icon pt-icon-lock"></span>
                        <input type={`${this.state.showNewPassword ? 'text' : 'password'}`} className="pt-input"
                            value={this.state.newPassword}
                            onFocus={this.handleOnFocusToHideFooter}
                            onBlur={this.handleOnFocusToBringFooter}
                            onChange={({ target }) => {
                                this.setState({ newPassword: target.value });
                                if (this.state.confirmPassword === target.value && target.value !== '')
                                    this.setState({ matchPassword: true });
                                else this.setState({ matchPassword: false });
                            }}

                            placeholder="New Password" />
                        <span onClick={() => { this.setState({ showNewPassword: !this.state.showNewPassword }); }} className={`password-eye pt-icon ${this.state.showNewPassword ? 'pt-icon-eye-on' : 'pt-icon-eye-off'}`}></span>
                    </div>
                    <Divider hidden />
                    <div className="pt-form-group pt-input-group pt-small" style={{ margin: 'auto', width: 200 }}>
                        <span className="pt-icon pt-icon-lock"></span>
                        <input type={`${this.state.showConfirmPassword ? 'text' : 'password'}`} className="pt-input"
                            value={this.state.confirmPassword}
                            onFocus={this.handleOnFocusToHideFooter}
                            onBlur={this.handleOnFocusToBringFooter}
                            onChange={({ target }) => {
                                this.setState({ confirmPassword: target.value });
                                if (this.state.newPassword === target.value && target.value !== '')
                                    this.setState({ matchPassword: true });
                                else this.setState({ matchPassword: false });
                            }}

                            placeholder="Confirm Password" />
                        <span onClick={() => { this.setState({ showConfirmPassword: !this.state.showConfirmPassword }); }} className={`password-eye pt-icon ${this.state.showConfirmPassword ? 'pt-icon-eye-on' : 'pt-icon-eye-off'}`}></span>
                    </div>
                    <Divider hidden />
                    <div className="pt-form-group pt-small" style={{ margin: 'auto', marginTop: 5, width: 200 }}>
                        <Button primary disabled={!this.state.newPassword || !this.state.confirmPassword}
                            onClick={this.onLogin} style={{ width: 180 }}>Reset</Button>

                        <a onClick={() => window.open(sessionStorage.getItem('url') + '?activeItem=Editor', '_self')} style={{ textDecoration: 'underline', textAlign: 'center', paddingTop: 10 }}>Go Back</a>
                    </div>
                    <Divider hidden />

                    {this.state.showLabel && !this.state.success &&
                        <Message negative style={{ margin: 'auto', width: 400 }} onDismiss={this.handleDismiss}>
                            <Message.Header>Reset Password failed!</Message.Header>
                            <p>{this.state.loginError}</p>
                        </Message>
                    }
                    {this.state.showLabel && this.state.success &&
                        <Message positive style={{ margin: 'auto', width: 400 }} onDismiss={this.handleDismiss}>
                            <Message.Header>Success</Message.Header>
                            <p>{this.state.loginError}</p>
                        </Message>
                    }

                </div>


        };

        // no if or switch statements :)
        let segValue = displayTabs[this.state.activeItem];

        return (
            <div className="loginHolder">
                <Grid stackable relaxed centered style={{ height: '100%', margin: 0 }} columns={1} >
                    <Grid.Column width={12}
                        style={{
                            backgroundColor: 'white',
                            border: '1px none #CCCCCC',
                            borderLeftStyle: 'solid',
                            borderRightStyle: 'solid',
                            position: 'relative',
                            margin: '0',
                            display: 'flex',
                            flexDirection: 'column',
                            minHeight: '100vh'
                        }}>

                        <Grid.Row >
                            {/* Header portion */}
                            <Image style={{ margin: 'auto' }} src={HeaderImage} />
                            <Divider hidden />

                            {/* page title */}
                            <Grid.Row>
                                <Grid.Column>
                                    <h2 style={{ textAlign: 'center' }}>Geographic Roadway Inventory Tool</h2>
                                </Grid.Column>
                            </Grid.Row>
                            <Divider hidden />

                            {/* Navigation */}
                            <Grid.Column width={4}>
                                <Menu pointing secondary style={{ border: '0px' }}>
                                    <Menu.Item name='Reset Password' active={this.state.activeItem === 'Reset'} onClick={this.handleItemClick} />
                                </Menu>
                            </Grid.Column>

                            <Divider hidden />
                            <Grid.Row>
                                <Divider />
                            </Grid.Row>

                            {/* Content */}
                            <Grid.Row>
                                {segValue}
                            </Grid.Row>
                        </Grid.Row>
                        <Divider hidden />

                        {/*Insert footer component*/}
                        <Footer />
                    </Grid.Column>
                </Grid>
            </div>
        );
    }

    switchMode = ({ target }) => {
        this.setState({ mode: target.value });
        console.log(target.value);
    }

    async componentDidMount() {

        if (!this.finishedExit) {
            this.setState({ visible: true });
        }

        const { search } = this.props.location;

        if (search === "?activeItem=Help") {
            this.setState({ activeItem: "Help" });
        } else if (search === "?activeItem=Editor") {
            this.setState({ activeItem: "Editor" });
        }
    }


    onLogin = (e) => {
        if (!this.state.matchPassword) {
            alert('New and Confirm password not matched!');
            this.setState({
                newPassword: "",
                confirmPassword: ""
            });
            return;
        }

        this.setState({ visible: false });
        this.finishedExit = true;

        console.log("login called");
        this.validateReset(e);
    }

    exitCallback = () => {
        if (this.finishedExit) {
            if (this.state.mode === "Gmaps") {
                this.props.history.push('/maing');
            }
            else if (this.state.mode === "Leaflet") {
                this.props.history.push('/mainl');
            }
            else if (this.state.mode === "Wrld") {
                this.props.history.push('/mainw');
            }
        }
    }

    exitCallbackRoute = (reroute = null) => {
        if (reroute) {
            this.props.history.push("/" + reroute);
        }
        else {
            this.props.history.push('/maing');
        }
    }

    componentDidUpdate() {

    }

    validateReset = (e) => {

        const passOldHash = sha256(this.state.oldPassword).toString('hex');

        $.ajax({
            type: 'POST',
            url: `${config.server}/resetpassword/authenticate`,
            data: {
                UserNameID: this.state.username,
                OldPassword: passOldHash, //hasha(this.state.password)
                NewPassword: this.state.newPassword,
            }// + salt = 'grit1234'
        })
            .done((data) => {
                console.log(data['message']);
                if (data['message'] === "success") {
                    this.setState({ showLabel: true })
                    this.setState({ success: true });
                    this.setState({
                        loginError: "Password has been reset successfully.",
                        username: "",
                        newPassword: "",
                        oldPassword: "",
                        confirmPassword: ""
                    });

                }
                else {
                    this.setState({ showLabel: true })
                    this.setState({ success: false });
                    this.setState({
                        loginError: "Incorrect username or old password",
                        username: "",
                        newPassword: "",
                        oldPassword: "",
                        confirmPassword: ""
                    });
                }
            })
            .fail((jqXhr) => {
                console.log('failed to connect to server');
                console.log(jqXhr);
            });

        e.preventDefault();
    }

}

export default ResetPassword;


// WEBPACK FOOTER //
// ./src/resetpassword.js